import { CreateTimeSlotDefinitionDaysOfWeekEnum } from "@/generated/openapi"

function all(): Set<CreateTimeSlotDefinitionDaysOfWeekEnum> {
  return new Set([
    CreateTimeSlotDefinitionDaysOfWeekEnum.Monday,
    CreateTimeSlotDefinitionDaysOfWeekEnum.Tuesday,
    CreateTimeSlotDefinitionDaysOfWeekEnum.Wednesday,
    CreateTimeSlotDefinitionDaysOfWeekEnum.Thursday,
    CreateTimeSlotDefinitionDaysOfWeekEnum.Friday,
    CreateTimeSlotDefinitionDaysOfWeekEnum.Saturday,
    CreateTimeSlotDefinitionDaysOfWeekEnum.Sunday,
  ])
}

function workdays(): Set<CreateTimeSlotDefinitionDaysOfWeekEnum> {
  return new Set([
    CreateTimeSlotDefinitionDaysOfWeekEnum.Monday,
    CreateTimeSlotDefinitionDaysOfWeekEnum.Tuesday,
    CreateTimeSlotDefinitionDaysOfWeekEnum.Wednesday,
    CreateTimeSlotDefinitionDaysOfWeekEnum.Thursday,
    CreateTimeSlotDefinitionDaysOfWeekEnum.Friday,
  ])
}

export {
  workdays,
  all
}
